import { X } from "lucide-react";
import { useEffect, useRef, type ReactNode } from "react";
import { calculateSheetViewport } from "../sheet-viewport";

export function Sheet(props: {
  title: string;
  description?: string;
  onClose: () => void;
  className?: string;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (dialog && !dialog.open) dialog.showModal();
  }, []);
  useEffect(() => {
    const dialog = ref.current;
    const viewport = window.visualViewport;
    if (!dialog || !viewport) return;

    const updateViewport = () => {
      const metrics = calculateSheetViewport(
        Math.max(window.innerHeight, document.documentElement.clientHeight),
        viewport.height,
        viewport.offsetTop,
      );
      dialog.style.setProperty("--sheet-mobile-height", `${metrics.height}px`);
      dialog.style.setProperty("--sheet-viewport-bottom", `${metrics.bottom}px`);
    };

    updateViewport();
    viewport.addEventListener("resize", updateViewport);
    viewport.addEventListener("scroll", updateViewport, { passive: true });
    window.addEventListener("resize", updateViewport);
    return () => {
      viewport.removeEventListener("resize", updateViewport);
      viewport.removeEventListener("scroll", updateViewport);
      window.removeEventListener("resize", updateViewport);
    };
  }, []);
  return (
    <dialog
      ref={ref}
      className={`sheet ${props.className ?? ""}`.trim()}
      onClose={props.onClose}
      onCancel={(event) => {
        event.preventDefault();
        props.onClose();
      }}
      aria-labelledby="sheet-title"
    >
      <div className="sheet-frame">
        <header className="sheet-header">
          <div>
            <h2 id="sheet-title">{props.title}</h2>
            {props.description ? <p>{props.description}</p> : null}
          </div>
          <button className="icon-button" type="button" aria-label="关闭" onClick={props.onClose}>
            <X aria-hidden="true" />
          </button>
        </header>
        {props.children}
      </div>
    </dialog>
  );
}
